import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppService, BASE_URL_CRUD } from '../app.service';
import { Observable } from 'rxjs/Observable';
@Injectable()
export class CommunityService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  postCommunity(administrationId: number, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administration/${administrationId}/community/create`;
    return this.post(this.endpoint, data);
  }

  getCommunityById(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/id/${communityId}`;
    return this.get(this.endpoint);
  }

  updateCommunity(communityId: number, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}`;
    return this.put(this.endpoint, data);
  }

  getUnits(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units/type`;
    return this.get(this.endpoint);
  }

  getUnitsByCommunity(communityId: number, sectorId?: number): Observable<any> {
    let query = '';
    if (sectorId) {
      query = `?sector_id=${sectorId}`;
    }
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units${query}`;
    return this.get(this.endpoint);
  }

  getUnitsByCommunityWithOutProperties(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units/without-properties`;
    return this.get(this.endpoint);
  }

  postUnit(communityId: number, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units/create`;
    return this.post(this.endpoint, data);
  }

  getUnitById(communityId: number, unitId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/units/${unitId}`;
    return this.get(this.endpoint);
  }

  updateUnit(communityId: number, data: any, unitId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/unit/${unitId}`;
    return this.put(this.endpoint, data);
  }

  deleteUnit(communityId: number, unitId: number) {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/unit/${unitId}`;
    return this.delete(this.endpoint);
  }
  getPeriodClose(communityId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/common-expenses/${communityId}/period-close`;
    return this.get(this.endpoint);
  }

  postCommunitySettingsDebtType(communityId: number, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/defaulters-parameters`;
    return this.post(this.endpoint, data);
  }

  changeOwner(unitId: number, data): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/units/${unitId}/change-owner`;
    return this.post(this.endpoint, data);
  }

  getHistoryUnitUser(unitId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/units/${unitId}/user-history`;
    return this.get(this.endpoint);
  }

}





// WEBPACK FOOTER //
// ./src/app/services/community.service.ts